import request from '@/utils/request'
export const Download = "/workflow/system/sign/process/proxy/manager/export";

export function queryPage(data) {
  return request({
    url: '/workflow/system/sign/process/proxy/manager/query_page',
    method: 'post',
    data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/workflow/system/sign/process/proxy/manager/save_or_update_v2',
    method: 'post',
    data
  })
}
export function updateSortNum(data) {
  return request({
    url: '/workflow/system/sign/process/proxy/manager/update_sort_num',
    method: 'post',
    data
  })
}
export function batchUpdateOrDelete(data) {
  return request({
    url: '/workflow/system/sign/process/proxy/manager/batch_update_or_delete',
    method: 'post',
    data
  })
}
export function get_detail(params) {
  return request({
    url: '/workflow/system/sign/process/proxy/manager/get_detail',
    method: 'get',
    params
  })
}